import { Link } from 'react-router-dom';

const UserInfo = ({ firstName, lastName, company, email }) => {
  return (
    <div className="rounded-xl border border-k-gray/60 bg-k-gray/10 p-4 mb-6">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-semibold text-k-h">
          {firstName} {lastName}
        </span>
        <Link
          to="/login"
          className="text-sm font-medium text-k-orange hover:underline"
        >
          This is not me
        </Link>
      </div>
      {email && <p className="mt-1 text-sm text-k-p">{email}</p>}
      {company && (
        <p className="mt-0.5 text-sm font-medium text-k-p">{company}</p>
      )}
    </div>
  );
};

export default UserInfo;
